import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, ValidatorFn } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
    selector: 'app-flamingo-input-dialog',
    template: `
    @if (data.title) {
      <div mat-dialog-title>{{ data.title }}</div>
    }
    <div mat-dialog-content>
      <form id="form" (submit)="onSubmit()">
        @if (data.description) {
          <p>{{ data.description }}</p>
        }
        <mat-form-field [appearance]="data.inputAppearance || 'fill'" style="width: 100%">
          @if (data.inputLabel) {
            <mat-label>{{ data.inputLabel }}</mat-label>
          }
          <input [formControl]="control" matInput [type]="data.inputType || 'text'" [placeholder]="data.inputPlaceholder || ''">
        </mat-form-field>
      </form>
    </div>
    <div mat-dialog-actions [align]="'end'">
      @if (data.actionCancel) {
        <button [tabIndex]="-1" type="button" mat-button
        [mat-dialog-close]="undefined" color="accent">{{ data.actionCancel }}</button>
      }
      <button form="form" type="submit" mat-raised-button color="accent">{{ data.actionConfirm || 'OK' }}</button>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlamingoInputDialogComponent {

  control!: UntypedFormControl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FlamingoInputDialogOptions,
    public dialogRef: MatDialogRef<FlamingoInputDialogComponent>,
  ) {
    this.control = new UntypedFormControl(data.inputValue, data.inputValidators);
  }

  onSubmit(): void {
    if (this.control.invalid) {
      return;
    }
    this.dialogRef.close(this.control.value);
  }
}

export interface FlamingoInputDialogOptions {
  title?: string;
  description?: string;
  actionConfirm?: string;
  actionCancel?: string;
  inputLabel?: string;
  inputPlaceholder?: string;
  inputValue?: any;
  inputType?: string;
  inputAppearance?: MatFormFieldAppearance;
  inputValidators?: ValidatorFn | ValidatorFn[];
}
